/** @format */

import { createContext } from 'react';
export const MachineContext = createContext();
